import type { paths } from '@pba/types-openapi-node';
import type { AxiosResponse } from 'axios';
import { getNodeApiAxiosInstance } from '#client';
import type { BodyRequest } from '#models';
import type { ChatroomDataObject } from '#models/services';
import { routes } from '#routes';

type CreateChatroomRequest = paths['/chatrooms']['post']['requestBody']['content']['application/json'];

export const createChatroom = async ({ body }: BodyRequest<CreateChatroomRequest>) =>
  getNodeApiAxiosInstance().post<ChatroomDataObject, AxiosResponse<ChatroomDataObject>>(routes.chatrooms.create, body);
